import React from 'react';
import { Grid, Link, makeStyles, Theme, createStyles } from '@material-ui/core';
import { TagDefinition } from '../../../../models';
import { TagList } from './TagList';
import { Card } from 'src/components/ui/card';
import { Text } from 'src/components/ui/typography';

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    container: {
      marginBottom: 16,
      overflow: 'visible',
    },
    clearAllButton: {
      cursor: 'pointer',
      color: '#338087',
      fontSize: 14,
    },
    headerContainer: {
      backgroundColor: '#e5e5e5',
      padding: '4px 16px',
    },
    paper: {
      maxHeight: 124,
      overflowY: 'auto',
      padding: '0 8px',
    },
  })
);

export interface SelectedTagsListProps {
  tags: TagDefinition[];
  selectedTags: string[];
  onTagSelect: (tagId: string) => void;
  clearAll?: () => void;
  hideWhenEmpty?: boolean;
}

export const SelectedTagsList: React.FC<SelectedTagsListProps> = ({
  tags,
  selectedTags,
  onTagSelect,
  clearAll,
  hideWhenEmpty = true,
}) => {
  const classes = useStyles();
  const hasSelectedTags = selectedTags && selectedTags.length > 0;

  if (!hasSelectedTags && hideWhenEmpty) return null;

  return (
    <Card className={classes.container}>
      <Grid container className={classes.headerContainer}>
        <Grid item>
          <Text fontSize={14} lineHeight="21px">
            Selected: {selectedTags.length}
          </Text>
        </Grid>
        <Grid item style={{ marginLeft: 'auto' }}>
          {clearAll && selectedTags.length > 0 && (
            <Link className={classes.clearAllButton} onClick={clearAll}>
              Clear All
            </Link>
          )}
        </Grid>
      </Grid>
      <div className={classes.paper}>
        <TagList
          tags={tags.filter((tag) => selectedTags.includes(tag.id))}
          onToggle={onTagSelect}
          selectedTags={selectedTags}
        />
      </div>
    </Card>
  );
};
